import AnimationHelper from './animation-helper'
import * as focusTrap from 'focus-trap'

export default class GroupSitesMenu {

  constructor () {
    this.mainHeader = document.querySelector('#main-header')

    if (this.mainHeader) {
      this.groupSitesToggle = this.mainHeader.querySelector('#secondary-menu-group-sites > a')
      this.groupSitesOverlay = document.querySelector('#group-sites-overlay')
      this.closeButton = this.groupSitesOverlay.querySelector('#group-sites-close')

      this.addGroupSitesMenuToggleHandler()
      this.addCloseButtonHandler()

      this.escapeKeyListener = this.handleEscapeKeyPress.bind(this)

      this.dialogFocusTrap = focusTrap.createFocusTrap(this.groupSitesOverlay, {
        onActivate: this.showGroupSitesOverlay.bind(this),
        onDeactivate: this.hideGroupSitesOverlay.bind(this),

        checkCanFocusTrap: (trapContainers) => {
          const results = trapContainers.map((trapContainer) => {
            return new Promise((resolve) => {
              const interval = setInterval(() => {
                if (getComputedStyle(trapContainer).visibility !== 'hidden') {
                  resolve()
                  clearInterval(interval)
                }
              }, 5)
            })
          })
          return Promise.all(results)
        }
      })
    }
  }

  addGroupSitesMenuToggleHandler () {
    this.groupSitesToggle.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      this.dialogFocusTrap.activate()
    })
  }

  showGroupSitesOverlay () {
    this.groupSitesOverlay.ariaHidden = false

    window.addEventListener('keydown', this.escapeKeyListener)

    AnimationHelper.triggerAnimation(this.groupSitesOverlay, 'active', 'in')
  }

  handleEscapeKeyPress (e) {
    if (e.key === 'Escape') {
      this.dialogFocusTrap.deactivate()
    }
  }

  hideGroupSitesOverlay () {
    this.groupSitesOverlay.ariaHidden = true

    window.removeEventListener('keydown', this.escapeKeyListener)

    AnimationHelper.triggerAnimation(this.groupSitesOverlay, 'active', 'out', 200)
  }

  addCloseButtonHandler () {
    this.closeButton.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      this.dialogFocusTrap.deactivate()
    })
  }

}